
import React, { ReactNode, useEffect, memo } from 'react';
import { DashboardSidebar } from '@/components/dashboard/sidebar';

interface DashboardLayoutProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children?: ReactNode;
}

// Use memo to prevent unnecessary re-renders
const MemoizedSidebar = memo(DashboardSidebar);

const DashboardLayout = ({ 
  title, 
  description, 
  actions, 
  children 
}: DashboardLayoutProps) => {
  // Debug effect to help troubleshoot rendering issues
  useEffect(() => {
    console.log('[DashboardLayout] Rendering dashboard layout', { title });
    return () => {
      console.log('[DashboardLayout] Dashboard layout unmounting');
    };
  }, [title]);

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      {/* Memoized sidebar to avoid unnecessary remounting */}
      <MemoizedSidebar />
      
      <div className="flex flex-col flex-1 overflow-hidden ml-[280px]">
        {(title || description || actions) && (
          <header className="bg-white border-b border-border px-8 py-5">
            <div className="flex items-center justify-between">
              <div>
                {title && <h1 className="text-2xl font-semibold">{title}</h1>}
                {description && (
                  <p className="text-sm text-muted-foreground mt-1">{description}</p>
                )}
              </div>
              {actions && <div className="flex items-center">{actions}</div>}
            </div>
          </header>
        )}
        
        <main className="flex-1 overflow-y-auto p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default React.memo(DashboardLayout);
